import "./cheques.scss";
import { useState } from "react";
import { toast } from "react-toastify";
import { formatJalaliDateFa } from "../../utils/formatJalaliDateFa";
import { FaToEnDigits } from "../../utils/faToEnDigits";
import { DeleteCheque } from "../../services/chequeService";
import { UpdateChequeStage } from "../../services/chequeService";
import IconButton from "../iconButton/iconButton";
import EditChequeComponent from "../editCheque/editCheque";
import Confirm from "../confirm/confirm";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";
import LoadingIcon from "../../assets/images/loadingGreen16.svg";

export default function Cheques({cheques, onManipulation, currentDate}) {
  const [editChequeId, setEditChequeId] = useState("");
  const [deleteChequeId, setDeleteChequeId] = useState("");
  const [statusLoading, setStatusLoading] = useState(null);
  const [deletLoading, setDeletLoading] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const date = FaToEnDigits(currentDate.format("YYYYMMDD"));
  
  const handleDeleteCheque = async (chequeId) => {
    setDeleteChequeId(chequeId);
    if (showConfirmation) {
       try {
        setDeletLoading(deleteChequeId);
        await DeleteCheque(deleteChequeId);
        setDeletLoading(null);
        setShowConfirmation(false);
        onManipulation();
      } catch (err) {
        setDeletLoading(null);
        toast.error(err.error, { toastId: "error" });
      }
    } else {
      setShowConfirmation(true);
    }
  }


  const updateChequeStage = async (chequeId, field, doneAt) => {
    var stage = doneAt === null ? date : null
    try {
      setStatusLoading(chequeId);
      await UpdateChequeStage(chequeId, field, stage);
      setStatusLoading(null);
      onManipulation();
    } catch (err) {
      setStatusLoading(null);
      toast.error(err.error, { toastId: "error" });
    }
  }

  const afterEditCheque = () => {
    setEditChequeId("");
    onManipulation();
  }

  const chequeCardRules = [
    {
      level: "high",
      className: "high",
      field: "fundedAt",
      label: "تامین شده در",
      actionLabel: "تامین چک",
      check: (c, date) => (c.reminderDate <= date && c.fundedAt === null) || (c.fundedAt > date && c.reminderDate <= date) || c.reminderDate === date || c.fundedAt === date,
      text: (c) =>
        `تامین چک بانک ${c.bankName} به شماره ${c.chequeNumber} شناسه صیادی ${c.sayadNumber} به مبلغ ${new Intl.NumberFormat(
          "fa-IR"
        ).format(Number(c.amount))} ریال در وجه ${c.owner} به کد/شناسه ملی ${
          c.ownerNationalCode
        } بابت ${c.reason}`,
    },
    {
      level: "medium",
      className: "medium",
      field: "registeredAt",
      label: "ثبت شده در",
      actionLabel: "ثبت چک",
      check: (c, date) => (c.date <= date && c.registeredAt === null)  || (c.registeredAt > date && c.date <= date) || c.registeredAt === date || c.date === date,
      text: (c) =>
        `ثبت چک بانک ${c.bankName} به شماره ${c.chequeNumber} شناسه صیادی ${c.sayadNumber} به مبلغ ${new Intl.NumberFormat(
          "fa-IR"
        ).format(Number(c.amount))} ریال در وجه ${c.owner} به کد/شناسه ملی ${
          c.ownerNationalCode
        } بابت ${c.reason} در سامانه صیاد`,
    },
    {
      level: "low",
      className: "low",
      field: "clearedAt",
      label: "پاس شده در",
      actionLabel: "پاس چک",
      check: (c, date) => (c.dueDate <= date && c.clearedAt === null) || (c.clearedAt > date && c.dueDate <= date) || c.clearedAt === date || c.dueDate === date ,
      text: (c) =>
        `پاس چک بانک ${c.bankName} به شماره ${c.chequeNumber} شناسه صیادی ${c.sayadNumber} به مبلغ ${new Intl.NumberFormat(
          "fa-IR"
        ).format(Number(c.amount))} ریال در وجه ${c.owner} به کد/شناسه ملی ${
          c.ownerNationalCode
        } بابت ${c.reason}`,
    },
  ];

  const buildChequeCards = (cheque, date) => {
    return chequeCardRules
      .filter(rule => rule.check(cheque, date))
      .map(rule => ({
        level: rule.level,
        className: rule.className,
        text: rule.text(cheque),
        label: rule.label,
        actionLabel: rule.actionLabel,
        field: rule.field,
        doneAt: cheque[rule.field],
      }));
  }

  return (
    <div className="cheques">
      <Confirm
        message="آیا از حذف این چک اطمینان دارید؟"
        display={showConfirmation}
        onConfirm={() => handleDeleteCheque()}
        onCancel={() => setShowConfirmation(false)}
        loading={deletLoading}
      />   
      {cheques.flatMap((cheque) => {
        if (statusLoading === cheque.ID) {
          return [
            <img
              key={`loading-${cheque.ID}`}
              src={LoadingIcon}
              alt="loading"
              className="loadingIcon"
            />,
          ];
        }
        const cards = buildChequeCards(cheque, date);
        return cards.map((card) => (
          <div key={`${cheque.ID}-${card.level}`} className={`chequeContent ${card.className} ${editChequeId === `${cheque.ID}-${card.level}` ? "editing" : ""} ${card.doneAt !== null ? "done" : ""}`}>
            {editChequeId === `${cheque.ID}-${card.level}` ? (
              <EditChequeComponent cheque={cheque} onCancel={() => afterEditCheque("")}  afterEditCheque={afterEditCheque}/>
            ) : (
              <div className="cheque">
                <div className="checkboxWrapper" onClick={() => updateChequeStage(cheque.ID, card.field, card.doneAt)}>
                  <div className="status"></div>
                  <div className="chequeText">
                    <p>
                      {card.text}
                      {card.doneAt !== null && ( <span className="chequeDoneDate">{card.label} {formatJalaliDateFa(card.doneAt)}</span>)}
                    </p>
                  </div>
                </div>
                <div className="chequeIconWrapper">
                  {card.doneAt === null && <IconButton icon={EditIcon} tooltip="ویرایش" onClick={() => setEditChequeId(`${cheque.ID}-${card.level}`)} className="editRemoveIcon"/>}
                  <IconButton icon={DeleteIcon} tooltip="حذف" onClick={() => handleDeleteCheque(cheque.ID)} loading={deletLoading === cheque.ID} className="editRemoveIcon"/>
                </div>
              </div>
            )}
          </div>
        ));
      })}
    </div>
  );
}
